import { FC } from "react";
import { useTranslation } from "react-i18next";

import { DateTemplate } from "@ryde/controls";

import { BulkActivateShiftTemplateFormFieldsEnum } from "./models";

export const BulkPassengerActivateShiftTemplateForm: FC = () => {
  const { t } = useTranslation();

  return (
    <DateTemplate
      name={BulkActivateShiftTemplateFormFieldsEnum.startDate}
      labelTranslated={t(
        `passenger.formLabel.${BulkActivateShiftTemplateFormFieldsEnum.startDate}`,
      )}
    />
  );
};
